import permissions from '@/enums/permissions';

const CreditAnalysisRouter = [
    {
        path: '/analise-de-credito',
        name: 'credit-analysis',
        component: () => import('@/views/pages/CreditAnalysis/CreditAnalysis.vue'),
        meta: {
            permissions: permissions.creditAnalysis,
        },
    },
    {
        path: '/pre-analise/:id',
        name: 'pre-analysis',
        component: () => import('@/views/pages/CreditAnalysis/PreAnalysis.vue'),
        meta: {
            permissions: permissions.creditAnalysis,
        },
    },
    {
        path: '/parametros',
        name: 'params',
        component: () => import('@/views/pages/CreditAnalysis/CreditProductParameters.vue'),
        meta: {
            permissions: permissions.creditAnalysis,
        },
    },
];

export default CreditAnalysisRouter;
